import { create } from "zustand"

import type { ChatSlice } from "./slices/chat-slice"

import { createChatSlice } from "./slices/chat-slice"
import { createNamespacedStore } from "./store-factory"

type AIParserStore = ChatSlice

function createAIParserStoreInstance() {
  return create<AIParserStore>()((set, get, api) => ({
    ...createChatSlice(set, get, api),
  }))
}

/**
 * Hook to get AI Parser store isolated by sessionType.
 *
 * @param sessionType - Session type identifier
 * @returns Zustand store hook for the specific sessionType
 */
export function useAIParserStore(sessionType: string) {
  return createNamespacedStore("ai-parser", sessionType, createAIParserStoreInstance)
}
